import { useState } from "react";
import variants from "./variants";

const TextArea = () => {
  const [active, setActive] = useState(variants[0]);
  const [value, setValue] = useState("");

  return (
    <article className={"rounded-xl border overflow-hidden transition-all duration-200 " + active.container + " " + active.accent}>
      <header className="px-4 py-3 border-b border-slate-700 bg-gradient-to-r from-amber-500/20 to-blue-500/20">
        <p className="text-xs uppercase tracking-widest text-slate-400">Component 63</p>
        <h3 className="text-sm md:text-base font-semibold text-slate-100">TextArea</h3>
      </header>
      <div className="p-4 space-y-3">
        <p className="text-sm text-slate-300 leading-relaxed">Multi-line text input field.</p>
        <div className="inline-flex items-center justify-center px-2.5 py-1 rounded border text-xs text-amber-300 border-amber-500/40 bg-amber-500/10">Forms</div>
        <div className="flex flex-wrap items-center gap-2 pt-1">
          {variants.map((variant) => (
            <button
              key={variant.name}
              type="button"
              onClick={() => setActive(variant)}
              className={"px-2 py-1 text-xs rounded border transition-colors " + (active.name === variant.name ? "border-slate-300 text-slate-100 bg-slate-700/70" : "border-slate-600 text-slate-300 hover:bg-slate-800")}
            >
              {variant.name}
            </button>
          ))}
        </div>
        
        {/* COMPONENTE REAL */}
        <div className="pt-4 border-t border-slate-700">
          <textarea
            placeholder="Write your message here..."
            value={value}
            onChange={(e) => setValue(e.target.value)}
            rows={4}
            className="w-full px-4 py-2 rounded-lg bg-slate-800 border border-slate-600 text-slate-100 placeholder-slate-500 focus:outline-none focus:border-amber-400 transition-colors resize-none"
          />
        </div>
      </div>
    </article>
  );
};

export default TextArea;


